<template>
  <nd-dialog
    v-model="visible"
    :footer="false"
  >
    <div
      class="pop"
      data-sensors-exposure-property-caseId="SignOut"
      data-sensors-exposure-property-msg_name="有额度挽留弹窗"
      data-sensors-exposure-event-name="PopupDisplay"
    >
      <div class="top">
        <div class="amount">{{ creditAmountInfo.max | currency }}</div>
        <div class="limit-container">
          <div class="amount-limit">最低 (元) {{ creditAmountInfo.min | currency }}</div>
          <div class="amount-limit">最高 (元) {{ creditAmountInfo.max | currency }}</div>
        </div>
      </div>
      <div class="title">
        您已获得<span class="text-red">{{ creditAmountInfo.max }}</span>元额度，提现通过率<span class="text-red">95%</span>真的要放弃吗？
      </div>
      <div
        class="text-lightGray signout-cell"
        @click="dismiss"
        data-sensors-click
      >
        是，额度太少，不想提现了
      </div>
      <div
        class="text-lightGray signout-cell"
        @click="dismiss"
        data-sensors-click
      >
        是，借款未通过，换平台尝试
      </div>
      <div
        class="text-lightGray signout-cell"
        @click="dismiss"
        data-sensors-click
      >
        是，借据已结清，没有借款需求了
      </div>
      <div
        class="withdraw text-red"
        @click="back"
        data-sensors-click
      >
        暂不注销，立即提现
      </div>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    creditAmountInfo: {
      type: Object,
      default: () => {
        return {
          current: 0,
          min: 0,
          max: 0
        }
      }
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    dismiss () {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

/deep/.nd-dialog-content {
  .default-content {
    padding-top: 0;
  }
}
.pop {
  display: flex;
  flex-direction: column;
  .top {
    width: 620px;
    height: 210px;
    background: url(./images/img_signout_amount_top@2x.png) no-repeat center center;
    background-size: contain;
    .amount {
      font-size: 46px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: #DDDDDD;
      line-height: 56px;
      padding-top: 108px;
      padding-left: 70px;
    }
    .limit-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 4px;
      padding-left: 70px;
      padding-right: 181px;
      .amount-limit {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #DDDDDD;
        line-height: 25px;
      }
    }
  }
  .title {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 50px;
    padding: 45px 50px;
    border-bottom: 1px solid #eeeeee;
    text-align: center;
  }
  .signout-cell {
    line-height: 110px;
    border-bottom: 1px solid #eee;
    text-align: center;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .withdraw {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 160px;
    text-align: center;
  }
}
.text-red {
  color: #FF4633;
}
.text-lightGray {
  color: #999999;
}
</style>